

































































































































/**
 * @copyright       Palace Resorts
 * @description     Pantalla principal para autorizadores
 * @author          Leticia Beltran
 * @creationDate    13/08/2021
 */
import MembersLayout from "@/layouts/Members.layout.vue";
import i18nMessages from "./i18n/messages";
import ResponseData from "@/models/store/ProveedoresTypesData";
import dataService from "@/services/proveedoresAPI";
import dataTableInvoice from "@/components/DatatableInvoice/DatatableInvoiceList.vue";
import GlobalMixin from "@/mixins/global";
import moment from "moment";
export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  components: {
    MembersLayout,
    dataTableInvoice,
  },
  props: ["id"],
  data: () => {
    return {
      moduleName: "SEARCH_INVOICE",
      person: null as any,
      personOptions: [] as any,
      loadingPersons: false,
      params: "",
      descriptionLimit: 60,
      menu1: false,
      company: [],
      chooseCompany: "",
      proveedor: {
        userID: "",
        userName: "",
      },

      folFacSearch: "",
      orderSearch: "",

      nombreProveedor: "",
      dataTableSTPS: [],
      loadingRSTPS: true,
      // para labels del buscador
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      menu2: false,
      select: "",
      status: [
        { name: "Inactivo - eliminado", id: 0 },
        { name: "Activo - Pendiente a ser autorizado", id: 1 },
        { name: "Autorizado", id: 2 },
        { name: "Rechazado", id: 3 },
        { name: "Cancelado por el SAT", id: 4 },
      ],
      isLoading: false,
    };
  },
  methods: {
    ini() {
      this.getID();
      this.getCompany();
    },
    btnSearch() {
      this.params = this.orderSearch;
    },

    // PROVEEDOR
    getID() {
      dataService.getByID(this.id).then((Response: ResponseData) => {
        this.proveedor = Response.data.data[0];
        this.nombreProveedor =
          (this.proveedor.userID ?? "") +
          " - " +
          (this.proveedor.userName ?? "");
        return "";
      });
    },
    async getCompany() {
      dataService.getCompany().then((Response: ResponseData) => {
        this.company = Response.data.data[0];
      });
    },
    async getdata(val: any) {
      dataService
        .getAllProvider(0, 10, val)
        .then((Response: ResponseData) => {
          this.personOptions = Response.data.data[0].data[0];
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    filterSociedad(item: any, queryText: any, itemText: any) {
      return (
        item.empresaClave.toLowerCase().includes(queryText.toLowerCase()) ||
        item.empresaRazonSocial.toLowerCase().includes(queryText.toLowerCase())
      );
    },
  },
  watch: {
    search(val: string) {
      // Items have already been requested
      if (this.isLoading) return;
      this.isLoading = true;
      this.getdata(val);
    },
  },
  mounted() {
    this.ini();
  },
});
